"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
const pluralRules = new Intl.PluralRules("en-US");
const pluralize = (count, singular, plural, hideNumber) => {
    const grammaticalNumber = pluralRules.select(count);
    switch (grammaticalNumber) {
        case "one":
            return hideNumber ? singular : count + " " + singular;
        case "other":
            return hideNumber ? plural : count + " " + plural;
        default:
            throw new Error("Unknown: " + grammaticalNumber);
    }
};
exports.pluralize = pluralize;
